/* agwc-orient.js - ORIENTATION on an L-family workstation PDP. THE REASONING
   IS blocks/agwc-orientation.liquid's header; an 8,000 B ceiling holds this
   file to its traps. */
(function () {
  'use strict';

  var ROOT = document.getElementById('agwc-orientation');
  if (!ROOT || window.AGWC_ORIENT) return;      /* no block, or armed */

  var HOST = up(ROOT, '.shopify-block') || ROOT;
  var CFG = '.product-header_option[data-option-name="configuration"]';
  var ATC = '#add-to-cart-btn, .add-to-cart-button';
  var TILE = '[data-agwc-orient-tile]';
  var LAY = '.product-header_layout';
  var LEFT = 'left', RIGHT = 'right';
  var PROP = ROOT.getAttribute('data-agwc-orient-prop') || 'Orientation';
  /* ONE source for the two values: the block's attributes */
  function val(s) { return ROOT.getAttribute('data-agwc-orient-val-' + s) || ''; }

  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  var TITLES = [], CODES = [];
  try {
    var isl = JSON.parse(document.getElementById('agwc-orient-data').textContent);
    TITLES = (isl.inline || []).map(norm);
    CODES = isl.codes || [];
  } catch (e) { TITLES = []; CODES = []; }
  var API = { side: RIGHT, shown: false, placed: false, eligible: 0, code: null,
    claimed: 0, last: null, error: null };
  window.AGWC_ORIENT = API;

  function q(s, r) { return (r || document).querySelector(s); }
  function all(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function up(e, s) { return (e && e.closest) ? e.closest(s) : null; }
  function stop(e, h) { e.preventDefault(); e.stopPropagation(); if (h) e.stopImmediatePropagation(); }

  function codeOf(i) { return CODES[TITLES.indexOf(norm(i && i.value))] || null; }

  function pform() { return q('form.native-product-form'); }

  /* R13c L-1 (EYE-33): ONE attribute, SIX mirrored nodes; NEVER a tile. */
  function hand() {
    var l = q(LAY);
    if (l) l[API.shown && API.side === LEFT ? 'setAttribute' : 'removeAttribute'](
      'data-agwc-side', LEFT);
  }

  function apply() {
    var f = pform(), i = f ? q('input[data-agwc-orient="prop"]', f) : null;
    hand();
    if (API.shown) {
      if (!i && f) {
        i = f.appendChild(document.createElement('input'));
        i.type = 'hidden';
        i.name = 'properties[' + PROP + ']';
        i.setAttribute('data-agwc-orient', 'prop');
      }
      if (i) i.value = val(API.side);
    } else if (i && i.parentNode) i.parentNode.removeChild(i);
    all(TILE, ROOT).forEach(function (t) {
      var on = t.getAttribute('data-agwc-orient-tile') === API.side;
      var b = q('.product-header_radio-button', t);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      if (b) b.classList.toggle('w--redirected-checked', on);
    });
  }

  function stamp() {
    var r = all(CFG + ' input[type="radio"]'), i, l, c, n = 0, code = null;
    for (i = 0; i < r.length; i++) {
      l = up(r[i], 'label.product-header_radio');
      if (!l) continue;
      c = codeOf(r[i]);
      if (c) { l.setAttribute('data-agwc-side-eligible', ''); l.setAttribute('data-agwc-code', c); n++; }
      else { l.removeAttribute('data-agwc-side-eligible'); l.removeAttribute('data-agwc-code'); }
      if (r[i].checked) code = c;
    }
    API.eligible = n;
    API.code = code;
    /* an <svg> has no `hidden` IDL property: the ATTRIBUTE, never el.hidden */
    all('svg[data-agwc-code]', ROOT).forEach(function (s) {
      if (!code || s.getAttribute('data-agwc-code') !== code) s.setAttribute('hidden', '');
      else s.removeAttribute('hidden');
    });
  }

  function evaluate() {
    var c = q(CFG + ' input[type="radio"]:checked'), ok = !!(c && codeOf(c)),
      r = q(CFG);
    API.placed = !!(r && r.parentNode);
    if (API.placed && r.nextSibling !== HOST) r.parentNode.insertBefore(HOST, r.nextSibling);
    stamp();
    if (!ok) API.side = RIGHT;
    API.shown = ok;
    ROOT.hidden = !ok;
    apply();
  }

  /* R13d THE CROSSFADE SEAM, and it is the ONLY thing this file knows about the
     fade. assets/agwc-orient-fx.js publishes API.fx and it is called with the
     PRE-FLIP picture still painted: it clones that picture over the real one,
     apply() flips the real one in the same tick, and the clone fades out over
     slick's own `speed`. No fx key loaded, or below 992, = an instant flip,
     which is what the theme itself does there. */
  function pick(s) {
    s = s === LEFT ? LEFT : RIGHT;
    if (API.side === s) return;
    API.side = s;
    if (API.fx) API.fx();
    apply();
    gal();
  }

  /* MOBILE, on a REAL pick only: the THEME's own scrollToGallery(), law for
     law - our tiles fire no `change`, so its listener never sees one. */
  function gal() {
    if (!window.matchMedia('(max-width: 768px)').matches) return;
    var g = q('.slick-product-gallery-container'), r;
    if (!g) return;
    r = g.getBoundingClientRect();
    if (r.top >= 0 && r.top < window.innerHeight * 0.3) return;
    window.scrollTo({ top: r.top + window.pageYOffset - 12, behavior: 'smooth' });
  }

  function tap(e) {                     /* OUR tile only */
    var t = up(e.target, TILE);
    if (!t || !ROOT.contains(t)) return false;
    stop(e);
    pick(t.getAttribute('data-agwc-orient-tile'));
    return true;
  }

  window.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'Configuration') evaluate();
  }, true);

  window.addEventListener('click', function (e) {
    if (tap(e)) return;
    /* BOTH hands write: the claim is ON whenever the control is SHOWN. */
    if (!API.shown) return;
    var t = up(e.target, ATC);
    if (t && !t.disabled) claim(e);
  }, true);

  window.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') tap(e);
  }, true);

  /* Enter in quantity reaches the SAME add; payment-terms never claimed. */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!API.shown || !f || !f.classList || !f.classList.contains('native-product-form')) return;
    if (e.submitter && !up(e.submitter, ATC)) return;
    claim(e);
  }, true);

  function claim(e) { stop(e, 1); API.claimed++; add(); }

  function add() {
    var f = pform(), idn = q('#product-variant-id');
    var qty = q('.is-quantity', f || document);
    var id = idn ? parseInt(idn.value, 10) : 0;
    var n = qty ? parseInt(qty.value, 10) : 1, p = {};
    if (!id) { API.error = 'no variant id'; return null; }
    if (!n || n < 1) n = 1;
    p[PROP] = val(API.side);
    API.last = { items: [{ id: id, quantity: n, properties: p }] };
    return fetch('/cart/add.js', { method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(API.last) }).then(function (res) {
      if (!res.ok) throw new Error('cart/add.js ' + res.status);
      return fetch('/cart.js');
    }).then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) {
      if (cart) all('.cart-count, [data-cart-count]').forEach(function (nd) {
        nd.textContent = cart.item_count;
      });
      return drawer();
    })['catch'](function (err) {
      API.error = String(err);
      if (window.console) console.error('agwc-orient', err);
      return null;
    });
  }

  function drawer() {
    var d = q('cart-drawer');
    if (!d || !d.open) return Promise.resolve(false);
    function o() { d.open(); return true; }
    return Promise.resolve(d.refreshCart ? d.refreshCart() : null).then(o, o);
  }

  /* readyState is 'interactive' while DEFERRED scripts run; evaluate() is
     idempotent - now, at DCL, at load. */
  API.evaluate = evaluate;
  evaluate();
  if (document.readyState !== 'complete') {
    document.addEventListener('DOMContentLoaded', evaluate, false);
    window.addEventListener('load', evaluate, false);
  }
})();
